import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=158d68c4"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreate.vue?vue&type=style&index=0&id=158d68c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports